<div class="dialog">
    <h6 mat-dialog-title>{{'Settings' | translate}}</h6>

    <label>{{'Brush Size' | translate}}: </label>
    <div mat-dialog-content>
        <mat-slider #slider (input)="change($event)" [value]="dataExchangeService.painting.brushSize" max="0.1" min="0.02"
                    step="0.01"></mat-slider>

        <div class="checkboxes">
            <mat-checkbox (change)="filterChanged($event)" [checked]="dataExchangeService.painting.marginalFilter"
                          class="check">{{'Filter' | translate}}
            </mat-checkbox>
            <br>
            <mat-checkbox (change)="roentgenChanged($event)" [checked]="dataExchangeService.painting.roentgen" class="check">
                Front and Back
            </mat-checkbox>
            <br>
            <mat-checkbox (change)="regionsChanged($event)" [checked]="dataExchangeService.painting.regions"
                          [disabled]="dataExchangeService.painting.regionsLoading" class="check"
                          (click)="regionsClick()">{{'Regions' | translate}}
            </mat-checkbox>
            <mat-error *ngIf="regionsClicked && dataExchangeService.painting.regionsLoading">
                Regions mode is still being initialized.
                Try again later.
            </mat-error>
        </div>

        <button [mat-dialog-close]="this.dataExchangeService.painting.brushSize" mat-button>{{'Ok' | translate}}</button>
    </div>
</div>
